const BasicLayoutIcon = ({
    size = 98,
    primaryColor = "#353535",
    secondaryColor = "#E0E0E0",
    tertiaryColor = "#F7F7F7",
}: {
    size?: number | string;
    primaryColor?: string;
    secondaryColor?: string;
    tertiaryColor?: string;
}) => {
    return (
        <svg width={size} height={"auto"} viewBox="0 0 98 109" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width={size} height={"auto"} rx="8" fill={tertiaryColor} />
            <rect x="12.25" y="12.25" width="73.5" height="22.5" rx="3.75" stroke={tertiaryColor} stroke-width="0.9" />
            <rect x="16" y="16" width="15" height="15" rx="1" fill={primaryColor} />
            <rect x="35" y="16" width="47" height="15" rx="1" fill={secondaryColor} />
            <rect x="12.25" y="43.25" width="73.5" height="22.5" rx="3.75" stroke={tertiaryColor} stroke-width="0.9" />
            <rect x="16" y="47" width="15" height="15" rx="1" fill={primaryColor} />
            <rect x="35" y="47" width="47" height="15" rx="1" fill={secondaryColor} />
            <rect x="12.25" y="74.25" width="73.5" height="22.5" rx="3.75" stroke={tertiaryColor} stroke-width="0.9" />
            <rect x="16" y="78" width="15" height="15" rx="1" fill={primaryColor} />
            <rect x="35" y="78" width="47" height="15" rx="1" fill={secondaryColor} />
        </svg>
    );
};

export default BasicLayoutIcon;
